<template>
  <div :class="$style.chart">
    <ul :class="$style.legend">
      <li :class="[$style.legend__item, $style['legend__item--messages']]">
        メッセージ数
      </li>
      <li :class="[$style.legend__item, $style['legend__item--matches']]">
        総マッチ数
      </li>
    </ul>
    <div :class="$style.chart__chart">
      <MatchChartRenderer :graph-data="graph" :styles="styles" />
    </div>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import type { GraphData } from './MatchChartRenderer.vue'
import MatchChartRenderer from './MatchChartRenderer.vue'
import type { PlannerID } from '@/types/app'
import type { MatchChartMatchStatusFragment } from './MatchChart.generated'

export default defineComponent({
  name: 'MatchChart',
  components: {
    MatchChartRenderer,
  },
  props: {
    statuses: {
      type: Array as PropType<MatchChartMatchStatusFragment[]>,
      required: true,
    },
    filteringPlannerId: {
      type: Number as PropType<Maybe<PlannerID>>,
    },
  },
  computed: {
    styles(): Partial<CSSStyleDeclaration> {
      return {
        position: 'relative',
        height: `260px`,
      }
    },
    filteredStatuses(): MatchChartMatchStatusFragment[] {
      if (this.filteringPlannerId === undefined) {
        return this.statuses
      }
      return this.statuses.filter(
        (status): boolean =>
          Number(status.plannerId) === this.filteringPlannerId
      )
    },
    graph(): GraphData[] {
      return this.filteredStatuses.map((status): GraphData => ({
        numberOfMessages: status.numberOfMessages,
        date: new Date(status.createdAt),
      }))
    },
  },
})
</script>

<style lang="scss" module>
.chart {
  &__chart {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}

.legend {
  &__item {
    display: flex;
    align-items: center;
    color: $color-text-and-object-high-emphasis;
    font-size: 12px;

    &:nth-child(n + 2) {
      margin-top: 8px;
    }

    &::before {
      display: inline-block;
      width: 24px;
      height: 12px;
      margin-right: 12px;
      border-radius: 2px;
      content: '';
    }

    &--matches {
      &::before {
        background-color: $color-surface-accent-primary;
      }
    }

    &--messages {
      &::before {
        background-color: $color-surface-accent-primary-light;
      }
    }
  }
}
</style>
